import React, { useState, useEffect } from "react";
import { LOGO_URL } from "../data/mockCategories";

const slides = [
  "https://images.unsplash.com/photo-1519676867240-f03562e64548?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=1200&q=80",
];

export default function HeroSlider({ onScrollToCategories }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero">
      {slides.map((imgUrl, index) => (
        <div
          key={index}
          className={`slide ${index === currentSlide ? "active" : ""}`}
        >
          <img src={imgUrl} alt={`Beyzade Slide ${index + 1}`} />
        </div>
      ))}

      <div className="hero-content">
        <img
          src={LOGO_URL}
          alt="Beyzade Baklava & Café"
          className="brand-logo"
        />
        <div className="hero-kicker">TRADITIONELLE SÜSSSPEISEN</div>
        <p className="hero-title">
          AİLE BÜYÜKLERİMİZDEN GELEN GELENEKSEL LEZZET
        </p>
        <button className="primary" onClick={onScrollToCategories}>
          KARTE ANSEHEN
        </button>
      </div>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
